import { competitiveIntelligenceProjectTranslations } from './competitive-intelligence-project'

const english = {
  competitive_intelligence_navigation_label: 'Competitive Intelligence sections',
  competitive_intelligence_nav_overview: 'Overview',
  competitive_intelligence_nav_research: 'Research',
  competitive_intelligence_nav_competitors: 'Competitors',
  competitive_intelligence_nav_market: 'Market Intelligence',
  competitive_intelligence_nav_social: 'Social & Publications',
  competitive_intelligence_research_description: 'Explore persisted research, clinical trials, and regulatory activity.',
  competitive_intelligence_research_search_placeholder: 'Search titles, authors, identifiers, conditions, companies, and devices…',
  competitive_intelligence_research_source_label: 'Source',
  competitive_intelligence_research_source_all: 'All',
  competitive_intelligence_research_source_pubmed: 'PubMed',
  competitive_intelligence_research_source_trials: 'Clinical Trials',
  competitive_intelligence_research_source_fda: 'FDA',
  competitive_intelligence_research_date_from: 'From date',
  competitive_intelligence_research_date_to: 'To date',
  competitive_intelligence_research_status: 'Status',
  competitive_intelligence_research_status_all: 'All statuses',
  competitive_intelligence_research_sort: 'Sort',
  competitive_intelligence_research_sort_newest: 'Newest first',
  competitive_intelligence_research_sort_oldest: 'Oldest first',
  competitive_intelligence_research_clear_filters: 'Clear filters',
  competitive_intelligence_research_results: 'results',
  competitive_intelligence_research_conditions: 'Conditions',
  competitive_intelligence_research_load_more: 'Load more',
  competitive_intelligence_research_loading: 'Loading research records',
  competitive_intelligence_research_detail_loading: 'Loading research record',
  competitive_intelligence_research_empty_corpus_title: 'No research records are available yet',
  competitive_intelligence_research_empty_corpus_description: 'The research corpus has not published any records yet.',
  competitive_intelligence_research_empty_search_title: 'No results match your search',
  competitive_intelligence_research_empty_search_description: 'Try a different title, identifier, condition, company, or device.',
  competitive_intelligence_research_empty_filter_title: 'No records match the selected filters',
  competitive_intelligence_research_empty_filter_description: 'Clear one or more filters to broaden the result set.',
  competitive_intelligence_research_error_title: 'Research could not be loaded',
  competitive_intelligence_research_error_description: 'An unexpected response prevented Research from loading.',
  competitive_intelligence_research_not_found_title: 'Research record not found',
  competitive_intelligence_research_not_found_description: 'This record no longer exists or the link is invalid.',
  competitive_intelligence_research_identifier: 'Source identifier',
  competitive_intelligence_research_collected: 'Collected',
  competitive_intelligence_research_context: 'Research context',
  competitive_intelligence_research_contributors: 'Authors / organization',
  competitive_intelligence_research_competitor: 'Competitor',
  competitive_intelligence_research_publication: 'Publication and iCite',
  competitive_intelligence_research_journal: 'Journal',
  competitive_intelligence_research_source_date: 'Source publication date',
  competitive_intelligence_research_citations: 'Citations',
  competitive_intelligence_research_rcr: 'Relative citation ratio',
  competitive_intelligence_research_trial: 'Clinical trial',
  competitive_intelligence_research_first_submitted: 'First submitted',
  competitive_intelligence_research_regulatory: 'Regulatory record',
  competitive_intelligence_research_device: 'Device',
  competitive_intelligence_research_applicant: 'Applicant',
  competitive_intelligence_research_product_code: 'Product code',
  competitive_intelligence_research_clearance_type: 'Clearance type',
  competitive_intelligence_research_decision: 'Decision',
  competitive_intelligence_research_view_fda_summary: 'View FDA summary',
  competitive_intelligence_research_original_source: 'Original source',
  competitive_intelligence_research_view_source: 'View original source',
  competitive_intelligence_activity_published: 'Published',
  competitive_intelligence_activity_updated: 'Updated',
  competitive_intelligence_activity_decided: 'Decision date',
  competitive_intelligence_activity_recorded: 'Recorded',
  competitive_intelligence_nav_assistants: 'AI Assistants',
  competitive_intelligence_research_summary: 'Research coverage summary',
  competitive_intelligence_research_total_records: 'total records',
  competitive_intelligence_research_by_competitor: 'By competitor',
  competitive_intelligence_research_competitor_all: 'All competitors',
  competitive_intelligence_research_condition_all: 'All conditions',
  competitive_intelligence_research_period: 'Period',
  competitive_intelligence_research_sort_added: 'Newly added',
  competitive_intelligence_research_sort_cited: 'Most cited',
  competitive_intelligence_research_sort_trending: 'Trending',
  competitive_intelligence_period_all: 'All time',
  competitive_intelligence_period_all_events: 'All events',
  competitive_intelligence_period_upcoming: 'Upcoming',
  competitive_intelligence_period_7d: 'Last 7 days',
  competitive_intelligence_period_30d: 'Last 30 days',
  competitive_intelligence_period_90d: 'Last 90 days',
  competitive_intelligence_period_12m: 'Last 12 months',
  competitive_intelligence_market_description: 'Track competitor events, product news, and social signals from their original sources.',
  competitive_intelligence_market_tabs: 'Market Intelligence categories',
  competitive_intelligence_market_tab_events: 'Events',
  competitive_intelligence_market_tab_news: 'News',
  competitive_intelligence_market_tab_social: 'Social',
  competitive_intelligence_market_platform: 'Platform',
  competitive_intelligence_market_type: 'Type',
  competitive_intelligence_market_all_platforms: 'All platforms',
  competitive_intelligence_market_all_types: 'All types',
  competitive_intelligence_market_search_events: 'Event name or location…',
  competitive_intelligence_market_search_news: 'Product, technology, or market…',
  competitive_intelligence_market_search_social: 'Search social posts…',
  competitive_intelligence_market_count_events: 'events',
  competitive_intelligence_market_count_news: 'news items',
  competitive_intelligence_market_count_social: 'posts',
  competitive_intelligence_market_booth: 'Booth',
  competitive_intelligence_market_view_post: 'View post',
  competitive_intelligence_market_loading: 'Loading market intelligence',
  competitive_intelligence_market_empty_title: 'No market signals match these filters',
  competitive_intelligence_market_empty_description: 'Clear one or more filters to broaden the result set.',
  competitive_intelligence_assistants_description: 'Open competitor-specific assistants maintained by the MagVenture Intelligence team.',
  competitive_intelligence_assistants_loading: 'Loading AI Assistants',
  competitive_intelligence_assistants_empty_title: 'AI Assistants are unavailable',
  competitive_intelligence_assistants_empty_description: 'No assistant configuration is available right now.',
  competitive_intelligence_assistant_specialist: 'Specialist',
  competitive_intelligence_assistant_maintained_by: 'Maintained by',
  competitive_intelligence_assistant_description: 'Ask focused questions about this competitor’s research, products, and market activity.',
  competitive_intelligence_assistant_open: 'Open in ChatGPT',
  competitive_intelligence_assistant_coming_soon: 'Coming soon',
}

const portuguese = {
  ...english,
  competitive_intelligence_navigation_label: 'Seções de Inteligência Competitiva',
  competitive_intelligence_nav_overview: 'Visão geral',
  competitive_intelligence_nav_research: 'Pesquisas',
  competitive_intelligence_nav_competitors: 'Concorrentes',
  competitive_intelligence_nav_market: 'Inteligência de Mercado',
  competitive_intelligence_nav_social: 'Social e publicações',
  competitive_intelligence_research_description: 'Explore pesquisas persistidas, ensaios clínicos e atividade regulatória.',
  competitive_intelligence_research_search_placeholder: 'Pesquise títulos, autores, identificadores, condições, empresas e dispositivos…',
  competitive_intelligence_research_source_label: 'Fonte',
  competitive_intelligence_research_source_all: 'Todas',
  competitive_intelligence_research_source_trials: 'Ensaios clínicos',
  competitive_intelligence_research_date_from: 'Data inicial',
  competitive_intelligence_research_date_to: 'Data final',
  competitive_intelligence_research_status: 'Status',
  competitive_intelligence_research_status_all: 'Todos os status',
  competitive_intelligence_research_sort: 'Ordenação',
  competitive_intelligence_research_sort_newest: 'Mais recentes',
  competitive_intelligence_research_sort_oldest: 'Mais antigos',
  competitive_intelligence_research_clear_filters: 'Limpar filtros',
  competitive_intelligence_research_results: 'resultados',
  competitive_intelligence_research_conditions: 'Condições',
  competitive_intelligence_research_load_more: 'Carregar mais',
  competitive_intelligence_research_loading: 'Carregando registros de pesquisa',
  competitive_intelligence_research_detail_loading: 'Carregando registro de pesquisa',
  competitive_intelligence_research_empty_corpus_title: 'Ainda não há registros de pesquisa',
  competitive_intelligence_research_empty_corpus_description: 'O corpus ainda não publicou registros.',
  competitive_intelligence_research_empty_search_title: 'Nenhum resultado corresponde à busca',
  competitive_intelligence_research_empty_search_description: 'Tente outro título, identificador, condição, empresa ou dispositivo.',
  competitive_intelligence_research_empty_filter_title: 'Nenhum registro corresponde aos filtros',
  competitive_intelligence_research_empty_filter_description: 'Remova um ou mais filtros para ampliar os resultados.',
  competitive_intelligence_research_error_title: 'Não foi possível carregar as pesquisas',
  competitive_intelligence_research_error_description: 'Uma resposta inesperada impediu o carregamento.',
  competitive_intelligence_research_not_found_title: 'Registro de pesquisa não encontrado',
  competitive_intelligence_research_not_found_description: 'Este registro não existe mais ou o link é inválido.',
  competitive_intelligence_research_identifier: 'Identificador da fonte',
  competitive_intelligence_research_collected: 'Coletado',
  competitive_intelligence_research_context: 'Contexto da pesquisa',
  competitive_intelligence_research_contributors: 'Autores / organização',
  competitive_intelligence_research_competitor: 'Concorrente',
  competitive_intelligence_research_publication: 'Publicação e iCite',
  competitive_intelligence_research_journal: 'Periódico',
  competitive_intelligence_research_source_date: 'Data informada pela fonte',
  competitive_intelligence_research_citations: 'Citações',
  competitive_intelligence_research_rcr: 'Índice relativo de citação',
  competitive_intelligence_research_trial: 'Ensaio clínico',
  competitive_intelligence_research_first_submitted: 'Primeiro envio',
  competitive_intelligence_research_regulatory: 'Registro regulatório',
  competitive_intelligence_research_device: 'Dispositivo',
  competitive_intelligence_research_applicant: 'Solicitante',
  competitive_intelligence_research_product_code: 'Código do produto',
  competitive_intelligence_research_clearance_type: 'Tipo de liberação',
  competitive_intelligence_research_decision: 'Decisão',
  competitive_intelligence_research_view_fda_summary: 'Ver resumo da FDA',
  competitive_intelligence_research_original_source: 'Fonte original',
  competitive_intelligence_research_view_source: 'Ver fonte original',
  competitive_intelligence_activity_published: 'Publicado',
  competitive_intelligence_activity_updated: 'Atualizado',
  competitive_intelligence_activity_decided: 'Data da decisão',
  competitive_intelligence_activity_recorded: 'Registrado',
  competitive_intelligence_nav_assistants: 'Assistentes de IA',
  competitive_intelligence_research_summary: 'Resumo da cobertura de pesquisas',
  competitive_intelligence_research_total_records: 'registros no total',
  competitive_intelligence_research_by_competitor: 'Por concorrente',
  competitive_intelligence_research_competitor_all: 'Todos os concorrentes',
  competitive_intelligence_research_condition_all: 'Todas as condições',
  competitive_intelligence_research_period: 'Período',
  competitive_intelligence_research_sort_added: 'Adicionados recentemente',
  competitive_intelligence_research_sort_cited: 'Mais citados',
  competitive_intelligence_research_sort_trending: 'Em alta',
  competitive_intelligence_period_all: 'Todo o período',
  competitive_intelligence_period_all_events: 'Todos os eventos',
  competitive_intelligence_period_upcoming: 'Próximos',
  competitive_intelligence_period_7d: 'Últimos 7 dias',
  competitive_intelligence_period_30d: 'Últimos 30 dias',
  competitive_intelligence_period_90d: 'Últimos 90 dias',
  competitive_intelligence_period_12m: 'Últimos 12 meses',
  competitive_intelligence_market_description: 'Acompanhe eventos, notícias de produtos e sinais sociais dos concorrentes com suas fontes originais.',
  competitive_intelligence_market_tabs: 'Categorias de Inteligência de Mercado',
  competitive_intelligence_market_tab_events: 'Eventos',
  competitive_intelligence_market_tab_news: 'Notícias',
  competitive_intelligence_market_tab_social: 'Social',
  competitive_intelligence_market_platform: 'Plataforma',
  competitive_intelligence_market_type: 'Tipo',
  competitive_intelligence_market_all_platforms: 'Todas as plataformas',
  competitive_intelligence_market_all_types: 'Todos os tipos',
  competitive_intelligence_market_search_events: 'Nome ou local do evento…',
  competitive_intelligence_market_search_news: 'Produto, tecnologia ou mercado…',
  competitive_intelligence_market_search_social: 'Pesquisar publicações…',
  competitive_intelligence_market_count_events: 'eventos',
  competitive_intelligence_market_count_news: 'notícias',
  competitive_intelligence_market_count_social: 'publicações',
  competitive_intelligence_market_booth: 'Estande',
  competitive_intelligence_market_view_post: 'Ver publicação',
  competitive_intelligence_market_loading: 'Carregando inteligência de mercado',
  competitive_intelligence_market_empty_title: 'Nenhum sinal de mercado corresponde aos filtros',
  competitive_intelligence_market_empty_description: 'Remova um ou mais filtros para ampliar os resultados.',
  competitive_intelligence_assistants_description: 'Abra assistentes específicos por concorrente mantidos pelo time de Inteligência da MagVenture.',
  competitive_intelligence_assistants_loading: 'Carregando Assistentes de IA',
  competitive_intelligence_assistants_empty_title: 'Assistentes de IA indisponíveis',
  competitive_intelligence_assistants_empty_description: 'Nenhuma configuração de assistente está disponível agora.',
  competitive_intelligence_assistant_specialist: 'Especialista',
  competitive_intelligence_assistant_maintained_by: 'Mantido por',
  competitive_intelligence_assistant_description: 'Faça perguntas focadas em pesquisas, produtos e atividade de mercado deste concorrente.',
  competitive_intelligence_assistant_open: 'Abrir no ChatGPT',
  competitive_intelligence_assistant_coming_soon: 'Em breve',
}

const spanish = {
  ...english,
  competitive_intelligence_navigation_label: 'Secciones de Inteligencia Competitiva',
  competitive_intelligence_nav_overview: 'Resumen',
  competitive_intelligence_nav_research: 'Investigación',
  competitive_intelligence_nav_competitors: 'Competidores',
  competitive_intelligence_nav_market: 'Mercado',
  competitive_intelligence_nav_social: 'Redes y publicaciones',
  competitive_intelligence_research_description: 'Explora investigaciones guardadas, ensayos clínicos y actividad regulatoria.',
  competitive_intelligence_research_search_placeholder: 'Buscar títulos, autores, identificadores, condiciones, empresas y dispositivos…',
  competitive_intelligence_research_source_label: 'Fuente',
  competitive_intelligence_research_source_all: 'Todas',
  competitive_intelligence_research_source_trials: 'Ensayos clínicos',
  competitive_intelligence_research_date_from: 'Fecha inicial',
  competitive_intelligence_research_date_to: 'Fecha final',
  competitive_intelligence_research_status: 'Estado',
  competitive_intelligence_research_status_all: 'Todos los estados',
  competitive_intelligence_research_sort: 'Orden',
  competitive_intelligence_research_sort_newest: 'Más recientes',
  competitive_intelligence_research_sort_oldest: 'Más antiguos',
  competitive_intelligence_research_clear_filters: 'Limpiar filtros',
  competitive_intelligence_research_results: 'resultados',
  competitive_intelligence_research_conditions: 'Condiciones',
  competitive_intelligence_research_load_more: 'Cargar más',
  competitive_intelligence_research_loading: 'Cargando registros de investigación',
  competitive_intelligence_research_detail_loading: 'Cargando registro de investigación',
  competitive_intelligence_research_empty_corpus_title: 'Aún no hay registros de investigación',
  competitive_intelligence_research_empty_corpus_description: 'El corpus todavía no ha publicado registros.',
  competitive_intelligence_research_empty_search_title: 'Ningún resultado coincide con la búsqueda',
  competitive_intelligence_research_empty_search_description: 'Prueba con otro título, identificador, condición, empresa o dispositivo.',
  competitive_intelligence_research_empty_filter_title: 'Ningún registro coincide con los filtros',
  competitive_intelligence_research_empty_filter_description: 'Quita uno o más filtros para ampliar los resultados.',
  competitive_intelligence_research_error_title: 'No se pudo cargar la investigación',
  competitive_intelligence_research_error_description: 'Una respuesta inesperada impidió la carga.',
  competitive_intelligence_research_not_found_title: 'Registro de investigación no encontrado',
  competitive_intelligence_research_not_found_description: 'Este registro ya no existe o el enlace no es válido.',
  competitive_intelligence_research_identifier: 'Identificador de la fuente',
  competitive_intelligence_research_collected: 'Recopilado',
  competitive_intelligence_research_context: 'Contexto de investigación',
  competitive_intelligence_research_contributors: 'Autores / organización',
  competitive_intelligence_research_competitor: 'Competidor',
  competitive_intelligence_research_publication: 'Publicación e iCite',
  competitive_intelligence_research_journal: 'Revista',
  competitive_intelligence_research_source_date: 'Fecha informada por la fuente',
  competitive_intelligence_research_citations: 'Citas',
  competitive_intelligence_research_rcr: 'Índice relativo de citas',
  competitive_intelligence_research_trial: 'Ensayo clínico',
  competitive_intelligence_research_first_submitted: 'Primer envío',
  competitive_intelligence_research_regulatory: 'Registro regulatorio',
  competitive_intelligence_research_device: 'Dispositivo',
  competitive_intelligence_research_applicant: 'Solicitante',
  competitive_intelligence_research_product_code: 'Código de producto',
  competitive_intelligence_research_clearance_type: 'Tipo de autorización',
  competitive_intelligence_research_decision: 'Decisión',
  competitive_intelligence_research_view_fda_summary: 'Ver resumen de la FDA',
  competitive_intelligence_research_original_source: 'Fuente original',
  competitive_intelligence_research_view_source: 'Ver fuente original',
  competitive_intelligence_activity_published: 'Publicado',
  competitive_intelligence_activity_updated: 'Actualizado',
  competitive_intelligence_activity_decided: 'Fecha de decisión',
  competitive_intelligence_activity_recorded: 'Registrado',
}

const german = {
  ...english,
  competitive_intelligence_navigation_label: 'Bereiche der Competitive Intelligence',
  competitive_intelligence_nav_overview: 'Übersicht',
  competitive_intelligence_nav_research: 'Forschung',
  competitive_intelligence_nav_competitors: 'Wettbewerber',
  competitive_intelligence_nav_market: 'Markt',
  competitive_intelligence_nav_social: 'Social Media & Publikationen',
  competitive_intelligence_research_description: 'Durchsuchen Sie gespeicherte Forschung, klinische Studien und regulatorische Aktivitäten.',
  competitive_intelligence_research_search_placeholder: 'Titel, Autoren, Kennungen, Indikationen, Unternehmen und Geräte suchen…',
  competitive_intelligence_research_source_label: 'Quelle',
  competitive_intelligence_research_source_all: 'Alle',
  competitive_intelligence_research_source_trials: 'Klinische Studien',
  competitive_intelligence_research_date_from: 'Von Datum',
  competitive_intelligence_research_date_to: 'Bis Datum',
  competitive_intelligence_research_status: 'Status',
  competitive_intelligence_research_status_all: 'Alle Status',
  competitive_intelligence_research_sort: 'Sortierung',
  competitive_intelligence_research_sort_newest: 'Neueste zuerst',
  competitive_intelligence_research_sort_oldest: 'Älteste zuerst',
  competitive_intelligence_research_clear_filters: 'Filter löschen',
  competitive_intelligence_research_results: 'Ergebnisse',
  competitive_intelligence_research_conditions: 'Indikationen',
  competitive_intelligence_research_load_more: 'Mehr laden',
  competitive_intelligence_research_loading: 'Forschungsdatensätze werden geladen',
  competitive_intelligence_research_detail_loading: 'Forschungsdatensatz wird geladen',
  competitive_intelligence_research_empty_corpus_title: 'Noch keine Forschungsdatensätze verfügbar',
  competitive_intelligence_research_empty_corpus_description: 'Der Forschungskorpus hat noch keine Datensätze veröffentlicht.',
  competitive_intelligence_research_empty_search_title: 'Keine Ergebnisse für Ihre Suche',
  competitive_intelligence_research_empty_search_description: 'Versuchen Sie einen anderen Titel, eine Kennung, Indikation, Firma oder ein Gerät.',
  competitive_intelligence_research_empty_filter_title: 'Keine Datensätze entsprechen den Filtern',
  competitive_intelligence_research_empty_filter_description: 'Entfernen Sie Filter, um die Ergebnismenge zu erweitern.',
  competitive_intelligence_research_error_title: 'Forschung konnte nicht geladen werden',
  competitive_intelligence_research_error_description: 'Eine unerwartete Antwort hat das Laden verhindert.',
  competitive_intelligence_research_not_found_title: 'Forschungsdatensatz nicht gefunden',
  competitive_intelligence_research_not_found_description: 'Dieser Datensatz existiert nicht mehr oder der Link ist ungültig.',
  competitive_intelligence_research_identifier: 'Quellenkennung',
  competitive_intelligence_research_collected: 'Erfasst',
  competitive_intelligence_research_context: 'Forschungskontext',
  competitive_intelligence_research_contributors: 'Autoren / Organisation',
  competitive_intelligence_research_competitor: 'Wettbewerber',
  competitive_intelligence_research_publication: 'Publikation und iCite',
  competitive_intelligence_research_journal: 'Fachzeitschrift',
  competitive_intelligence_research_source_date: 'Datum der Quelle',
  competitive_intelligence_research_citations: 'Zitationen',
  competitive_intelligence_research_rcr: 'Relatives Zitationsverhältnis',
  competitive_intelligence_research_trial: 'Klinische Studie',
  competitive_intelligence_research_first_submitted: 'Erstmals eingereicht',
  competitive_intelligence_research_regulatory: 'Regulatorischer Datensatz',
  competitive_intelligence_research_device: 'Gerät',
  competitive_intelligence_research_applicant: 'Antragsteller',
  competitive_intelligence_research_product_code: 'Produktcode',
  competitive_intelligence_research_clearance_type: 'Zulassungsart',
  competitive_intelligence_research_decision: 'Entscheidung',
  competitive_intelligence_research_view_fda_summary: 'FDA-Zusammenfassung ansehen',
  competitive_intelligence_research_original_source: 'Originalquelle',
  competitive_intelligence_research_view_source: 'Originalquelle ansehen',
  competitive_intelligence_activity_published: 'Veröffentlicht',
  competitive_intelligence_activity_updated: 'Aktualisiert',
  competitive_intelligence_activity_decided: 'Entscheidungsdatum',
  competitive_intelligence_activity_recorded: 'Erfasst',
}

const japanese = {
  ...english,
  competitive_intelligence_navigation_label: '競合インテリジェンスのセクション',
  competitive_intelligence_nav_overview: '概要',
  competitive_intelligence_nav_research: 'リサーチ',
  competitive_intelligence_nav_competitors: '競合企業',
  competitive_intelligence_nav_market: '市場',
  competitive_intelligence_nav_social: 'ソーシャル・出版物',
  competitive_intelligence_research_description: '保存済みの研究、臨床試験、規制関連情報を検索します。',
  competitive_intelligence_research_search_placeholder: 'タイトル、著者、識別子、疾患、企業、機器を検索…',
  competitive_intelligence_research_source_label: '情報源',
  competitive_intelligence_research_source_all: 'すべて',
  competitive_intelligence_research_source_trials: '臨床試験',
  competitive_intelligence_research_date_from: '開始日',
  competitive_intelligence_research_date_to: '終了日',
  competitive_intelligence_research_status: 'ステータス',
  competitive_intelligence_research_status_all: 'すべてのステータス',
  competitive_intelligence_research_sort: '並び順',
  competitive_intelligence_research_sort_newest: '新しい順',
  competitive_intelligence_research_sort_oldest: '古い順',
  competitive_intelligence_research_clear_filters: 'フィルターをクリア',
  competitive_intelligence_research_results: '件',
  competitive_intelligence_research_conditions: '対象疾患',
  competitive_intelligence_research_load_more: 'さらに読み込む',
  competitive_intelligence_research_loading: '研究レコードを読み込んでいます',
  competitive_intelligence_research_detail_loading: '研究レコードを読み込んでいます',
  competitive_intelligence_research_empty_corpus_title: '研究レコードはまだありません',
  competitive_intelligence_research_empty_corpus_description: '研究コーパスにはまだレコードが公開されていません。',
  competitive_intelligence_research_empty_search_title: '検索条件に一致する結果がありません',
  competitive_intelligence_research_empty_search_description: '別のタイトル、識別子、疾患、企業、機器をお試しください。',
  competitive_intelligence_research_empty_filter_title: '選択したフィルターに一致するレコードがありません',
  competitive_intelligence_research_empty_filter_description: 'フィルターを解除して検索範囲を広げてください。',
  competitive_intelligence_research_error_title: 'リサーチを読み込めませんでした',
  competitive_intelligence_research_error_description: '予期しない応答により読み込みできませんでした。',
  competitive_intelligence_research_not_found_title: '研究レコードが見つかりません',
  competitive_intelligence_research_not_found_description: 'このレコードは存在しないか、リンクが無効です。',
  competitive_intelligence_research_identifier: '情報源ID',
  competitive_intelligence_research_collected: '収集日時',
  competitive_intelligence_research_context: '研究コンテキスト',
  competitive_intelligence_research_contributors: '著者 / 組織',
  competitive_intelligence_research_competitor: '競合企業',
  competitive_intelligence_research_publication: '出版情報とiCite',
  competitive_intelligence_research_journal: 'ジャーナル',
  competitive_intelligence_research_source_date: '情報源の公開日',
  competitive_intelligence_research_citations: '引用数',
  competitive_intelligence_research_rcr: '相対引用率',
  competitive_intelligence_research_trial: '臨床試験',
  competitive_intelligence_research_first_submitted: '初回提出日',
  competitive_intelligence_research_regulatory: '規制レコード',
  competitive_intelligence_research_device: '機器',
  competitive_intelligence_research_applicant: '申請者',
  competitive_intelligence_research_product_code: '製品コード',
  competitive_intelligence_research_clearance_type: '承認種別',
  competitive_intelligence_research_decision: '決定',
  competitive_intelligence_research_view_fda_summary: 'FDA概要を表示',
  competitive_intelligence_research_original_source: '原典',
  competitive_intelligence_research_view_source: '原典を表示',
  competitive_intelligence_activity_published: '公開日',
  competitive_intelligence_activity_updated: '更新日',
  competitive_intelligence_activity_decided: '決定日',
  competitive_intelligence_activity_recorded: '記録日',
}

const chinese = {
  ...english,
  competitive_intelligence_navigation_label: '竞争情报栏目',
  competitive_intelligence_nav_overview: '概览',
  competitive_intelligence_nav_research: '研究',
  competitive_intelligence_nav_competitors: '竞争对手',
  competitive_intelligence_nav_market: '市场',
  competitive_intelligence_nav_social: '社交与出版物',
  competitive_intelligence_research_description: '浏览已保存的研究、临床试验和监管活动。',
  competitive_intelligence_research_search_placeholder: '搜索标题、作者、标识符、病症、公司和设备…',
  competitive_intelligence_research_source_label: '来源',
  competitive_intelligence_research_source_all: '全部',
  competitive_intelligence_research_source_trials: '临床试验',
  competitive_intelligence_research_date_from: '开始日期',
  competitive_intelligence_research_date_to: '结束日期',
  competitive_intelligence_research_status: '状态',
  competitive_intelligence_research_status_all: '全部状态',
  competitive_intelligence_research_sort: '排序',
  competitive_intelligence_research_sort_newest: '最新优先',
  competitive_intelligence_research_sort_oldest: '最早优先',
  competitive_intelligence_research_clear_filters: '清除筛选',
  competitive_intelligence_research_results: '条结果',
  competitive_intelligence_research_conditions: '病症',
  competitive_intelligence_research_load_more: '加载更多',
  competitive_intelligence_research_loading: '正在加载研究记录',
  competitive_intelligence_research_detail_loading: '正在加载研究详情',
  competitive_intelligence_research_empty_corpus_title: '暂无研究记录',
  competitive_intelligence_research_empty_corpus_description: '研究语料库尚未发布记录。',
  competitive_intelligence_research_empty_search_title: '没有符合搜索条件的结果',
  competitive_intelligence_research_empty_search_description: '请尝试其他标题、标识符、病症、公司或设备。',
  competitive_intelligence_research_empty_filter_title: '没有符合所选筛选条件的记录',
  competitive_intelligence_research_empty_filter_description: '请清除部分筛选条件以扩大结果范围。',
  competitive_intelligence_research_error_title: '无法加载研究数据',
  competitive_intelligence_research_error_description: '意外响应导致加载失败。',
  competitive_intelligence_research_not_found_title: '未找到研究记录',
  competitive_intelligence_research_not_found_description: '该记录已不存在或链接无效。',
  competitive_intelligence_research_identifier: '来源标识符',
  competitive_intelligence_research_collected: '采集时间',
  competitive_intelligence_research_context: '研究背景',
  competitive_intelligence_research_contributors: '作者 / 机构',
  competitive_intelligence_research_competitor: '竞争对手',
  competitive_intelligence_research_publication: '出版信息与 iCite',
  competitive_intelligence_research_journal: '期刊',
  competitive_intelligence_research_source_date: '来源发布日期',
  competitive_intelligence_research_citations: '引用次数',
  competitive_intelligence_research_rcr: '相对引用比率',
  competitive_intelligence_research_trial: '临床试验',
  competitive_intelligence_research_first_submitted: '首次提交',
  competitive_intelligence_research_regulatory: '监管记录',
  competitive_intelligence_research_device: '设备',
  competitive_intelligence_research_applicant: '申请人',
  competitive_intelligence_research_product_code: '产品代码',
  competitive_intelligence_research_clearance_type: '批准类型',
  competitive_intelligence_research_decision: '决定',
  competitive_intelligence_research_view_fda_summary: '查看 FDA 摘要',
  competitive_intelligence_research_original_source: '原始来源',
  competitive_intelligence_research_view_source: '查看原始来源',
  competitive_intelligence_activity_published: '发布日期',
  competitive_intelligence_activity_updated: '更新日期',
  competitive_intelligence_activity_decided: '决定日期',
  competitive_intelligence_activity_recorded: '记录日期',
}

const hindi = {
  ...english,
  competitive_intelligence_navigation_label: 'प्रतिस्पर्धी इंटेलिजेंस अनुभाग',
  competitive_intelligence_nav_overview: 'अवलोकन',
  competitive_intelligence_nav_research: 'अनुसंधान',
  competitive_intelligence_nav_competitors: 'प्रतिस्पर्धी',
  competitive_intelligence_nav_market: 'बाज़ार',
  competitive_intelligence_nav_social: 'सोशल और प्रकाशन',
  competitive_intelligence_research_description: 'संग्रहीत शोध, क्लिनिकल ट्रायल और नियामक गतिविधि देखें।',
  competitive_intelligence_research_search_placeholder: 'शीर्षक, लेखक, पहचानकर्ता, स्थितियाँ, कंपनियाँ और उपकरण खोजें…',
  competitive_intelligence_research_source_label: 'स्रोत',
  competitive_intelligence_research_source_all: 'सभी',
  competitive_intelligence_research_source_trials: 'क्लिनिकल ट्रायल',
  competitive_intelligence_research_date_from: 'आरंभ तिथि',
  competitive_intelligence_research_date_to: 'समाप्ति तिथि',
  competitive_intelligence_research_status: 'स्थिति',
  competitive_intelligence_research_status_all: 'सभी स्थितियाँ',
  competitive_intelligence_research_sort: 'क्रम',
  competitive_intelligence_research_sort_newest: 'नवीनतम पहले',
  competitive_intelligence_research_sort_oldest: 'सबसे पुराने पहले',
  competitive_intelligence_research_clear_filters: 'फ़िल्टर हटाएँ',
  competitive_intelligence_research_results: 'परिणाम',
  competitive_intelligence_research_conditions: 'स्थितियाँ',
  competitive_intelligence_research_load_more: 'और लोड करें',
  competitive_intelligence_research_loading: 'अनुसंधान रिकॉर्ड लोड हो रहे हैं',
  competitive_intelligence_research_detail_loading: 'अनुसंधान रिकॉर्ड लोड हो रहा है',
  competitive_intelligence_research_empty_corpus_title: 'अभी कोई अनुसंधान रिकॉर्ड उपलब्ध नहीं है',
  competitive_intelligence_research_empty_corpus_description: 'अनुसंधान संग्रह ने अभी रिकॉर्ड प्रकाशित नहीं किए हैं।',
  competitive_intelligence_research_empty_search_title: 'आपकी खोज से कोई परिणाम नहीं मिला',
  competitive_intelligence_research_empty_search_description: 'कोई दूसरा शीर्षक, पहचानकर्ता, स्थिति, कंपनी या उपकरण आज़माएँ।',
  competitive_intelligence_research_empty_filter_title: 'चुने गए फ़िल्टर से कोई रिकॉर्ड नहीं मिला',
  competitive_intelligence_research_empty_filter_description: 'परिणाम बढ़ाने के लिए एक या अधिक फ़िल्टर हटाएँ।',
  competitive_intelligence_research_error_title: 'अनुसंधान लोड नहीं हो सका',
  competitive_intelligence_research_error_description: 'अप्रत्याशित प्रतिक्रिया के कारण लोड नहीं हो सका।',
  competitive_intelligence_research_not_found_title: 'अनुसंधान रिकॉर्ड नहीं मिला',
  competitive_intelligence_research_not_found_description: 'यह रिकॉर्ड अब मौजूद नहीं है या लिंक अमान्य है।',
  competitive_intelligence_research_identifier: 'स्रोत पहचानकर्ता',
  competitive_intelligence_research_collected: 'संग्रहित',
  competitive_intelligence_research_context: 'अनुसंधान संदर्भ',
  competitive_intelligence_research_contributors: 'लेखक / संगठन',
  competitive_intelligence_research_competitor: 'प्रतिस्पर्धी',
  competitive_intelligence_research_publication: 'प्रकाशन और iCite',
  competitive_intelligence_research_journal: 'जर्नल',
  competitive_intelligence_research_source_date: 'स्रोत प्रकाशन तिथि',
  competitive_intelligence_research_citations: 'उद्धरण',
  competitive_intelligence_research_rcr: 'सापेक्ष उद्धरण अनुपात',
  competitive_intelligence_research_trial: 'क्लिनिकल ट्रायल',
  competitive_intelligence_research_first_submitted: 'पहली बार जमा',
  competitive_intelligence_research_regulatory: 'नियामक रिकॉर्ड',
  competitive_intelligence_research_device: 'उपकरण',
  competitive_intelligence_research_applicant: 'आवेदक',
  competitive_intelligence_research_product_code: 'उत्पाद कोड',
  competitive_intelligence_research_clearance_type: 'अनुमोदन प्रकार',
  competitive_intelligence_research_decision: 'निर्णय',
  competitive_intelligence_research_view_fda_summary: 'FDA सारांश देखें',
  competitive_intelligence_research_original_source: 'मूल स्रोत',
  competitive_intelligence_research_view_source: 'मूल स्रोत देखें',
  competitive_intelligence_activity_published: 'प्रकाशित',
  competitive_intelligence_activity_updated: 'अपडेट किया गया',
  competitive_intelligence_activity_decided: 'निर्णय तिथि',
  competitive_intelligence_activity_recorded: 'दर्ज किया गया',
}

export const competitiveIntelligenceResearchTranslations = {
  English: { ...english, ...competitiveIntelligenceProjectTranslations.English },
  Portuguese: { ...portuguese, ...competitiveIntelligenceProjectTranslations.Portuguese },
  Spanish: { ...spanish, ...competitiveIntelligenceProjectTranslations.Spanish },
  German: { ...german, ...competitiveIntelligenceProjectTranslations.German },
  Japanese: { ...japanese, ...competitiveIntelligenceProjectTranslations.Japanese },
  Hindi: { ...hindi, ...competitiveIntelligenceProjectTranslations.Hindi },
  Chinese: { ...chinese, ...competitiveIntelligenceProjectTranslations.Chinese },
}
